import { AutogenLayoutOfficeTimecardHistory } from "./autogen/AutogenLayoutOfficeTimecardHistory";
import { DataSourceMode, DataSourceModeChangeEvent, DropdownItem } from "@mcleod/components";

export class OfficeTimecardHistory extends AutogenLayoutOfficeTimecardHistory {

    onLoad(): void | Promise<void> {
        this.layoutTimecardDetails.textboxDrsPayrollHistpayperiodStart.field = "off_payroll_hist.payperiod_start";
        this.layoutTimecardDetails.textboxDrsPayrollHistpayperiodEnd.field = "off_payroll_hist.payperiod_end";
        this.layoutTimecardDetails.replaceMainDatasource(this.sourceTimecardHist);
        this.layoutGLDistributionTable.replaceMainDatasource(this.sourceJournalOffice);
        this.layoutGLDistributionTable.tableGLDistribution.removeColumn("columnHeaderOrderNumber");
        this.layoutTimecardDetails.textboxPayMethod.items = [
            new DropdownItem("H", "Hourly"),
            new DropdownItem("S", "Salary")
        ];
    }

    /** This is an event handler for the afterModeChange event of sourceTimecardHist. */
    sourceTimecardHistAfterModeChange(event: DataSourceModeChangeEvent) {
        this.dataheaderTimecardHistory.showExecute = event.newMode === DataSourceMode.SEARCH;
    }
}
